import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { persistSettingsServiceBuilder } from '@common-modules/common-persistency/persist-settings-service-builder';
import { PersistSettingsService } from '@common-modules/common-persistency/persist-settings.service';
import { PersistencyTypes } from '@common-modules/common-persistency/persistency-types';
import { ConfigurableFormModule } from '@common-modules/configurable-form/configurable-form.module';
import { ConfigurableFilterComponent } from './configurable-filter/configurable-filter.component';

@NgModule({
  declarations: [ConfigurableFilterComponent],
  imports: [CommonModule, ConfigurableFormModule],
  exports: [ConfigurableFilterComponent],
  providers: [
    {
      provide: PersistSettingsService,
      useClass: persistSettingsServiceBuilder(PersistencyTypes.Backend),
    },
  ],
})
export class ConfigurableFiltersModule {}
